import L from 'leaflet';

L.Control.ZoomHome = L.Control.extend({
    options: {
        position: 'topright',
    },

    onAdd: function (map) {
        const container = L.DomUtil.create('div', 'leaflet-control-zoomhome leaflet-bar leaflet-control');

        this.link = L.DomUtil.create('a', 'leaflet-bar-part', container);
        this.link.href = '#';

        this._map = map;

        L.DomEvent.disableClickPropagation(container);

        L.DomEvent.on(this.link, 'click', this._click, this);

        return container;
    },

    _click: function (e) {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        this._map.fitBounds(this.options.defaultBounds);
    },
});

L.control.zoomHome = (opts) => {
    return new L.Control.ZoomHome(opts);
};
